import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { IMPORT_SECURITY_LIST } from '../../../mutations';
import { CloudUpload } from '@mui/icons-material';
import { IconButton } from '@totalsoft/rocket-ui';

const ImportAction = ({ saving, setSaving }) => {
  const [t] = useTranslation();

  const [importSecurityList] = useMutation(IMPORT_SECURITY_LIST, {
    onError: () => {
      setSaving(false);
    }
  });

  const onImport = selectedFile => {
    if (!selectedFile) return;
    setSaving(true);
    importSecurityList({ variables: { input: selectedFile } });
  };

  return (
    <Tooltip placement='top' title={t('Authorization.Import')}>
      <div>
        <input
          style={{ display: 'none' }}
          value={''}
          type='file'
          id='selectFile'
          multiple
          accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
          onChange={event => onImport(event.target.files[0])}
          disabled={saving}
        />
        <label htmlFor='selectFile'>
          <IconButton id={'importBtn'} variant='contained' component='span' color='primary' disabled={saving}>
            <CloudUpload />
          </IconButton>
        </label>
      </div>
    </Tooltip>
  );
};

ImportAction.propTypes = {
  saving: PropTypes.bool.isRequired,
  setSaving: PropTypes.func.isRequired
};
export default ImportAction;
